import Select from "react-select";
import React, { useState, useRef, useEffect } from "react";
import { showNotification } from "services/NotificationService";
import { customMultiSelectStyles } from "commons/styles/CustomStyles";

const MultiSelectFilter = ({ column, handleFilterChange, filterValue }) => {
  const { id, isSelectionLocked, lockedValues = [] } = column;
  const [open, setOpen] = useState(false);
  const selectRef = useRef(null);
  
  filterValue = filterValue || [];
  if (!Array.isArray(filterValue)) {
    filterValue = [filterValue];
  }
  var filterNormed = [];
  if (column.filterOptions.length > 0) {
    filterValue.forEach((state, i) => {
      if (typeof state === "string") {
        filterNormed.push(
          column.filterOptions.filter(
            (element) => element.id === state || element.name === state
          )[0]
        );
      } else {
        filterNormed.push(state);
      }
    });
  }
  const normalizedValue = filterNormed;

  const onChange = (selectedOptions) => {
    let next = selectedOptions || [];

    if (isSelectionLocked && lockedValues.length > 0) {
      const lockedSet = new Set(lockedValues);
      const prevLocked = normalizedValue.filter(
        (opt) => opt && lockedSet.has(opt.id)
      );

      const nextIds = new Set(next.map((opt) => opt && opt.id));
      const missingLocked = prevLocked.filter((opt) => opt && !nextIds.has(opt.id));

      if (missingLocked.length > 0) {
        // Re-add locked options that user attempted to remove
        next = [...next, ...missingLocked];

        // Mirror master behavior: mention the first locked filter by name
        const firstLocked = missingLocked[0];
        const lockedName = firstLocked?.name ?? "This";

        showNotification({
          title: `Cannot remove ${lockedName} filter!`,
          message: `${lockedName} filter is locked and cannot be removed.`,
          position: "tr",
          type: "warning",
        });
      }
    }

    handleFilterChange(id, next, column);
  };

  const handleFocus = () => {
    // Open menu when select receives focus
    setOpen(true);
  };

  const handleBlur = (e) => {
    // Check if focus is moving outside the select component
    const currentTarget = e.currentTarget;
    const relatedTarget = e.relatedTarget;
    
    // If focus is moving to another element (not within the select), close menu
    if (relatedTarget && !currentTarget.contains(relatedTarget)) {
      setOpen(false);
    }
  };

  const handleKeyDown = (e) => {
    // Close menu on Tab key and ensure focus moves to next element
    if (e.key === 'Tab' && open) {
      setOpen(false);
    }
  };


  return (
    <div id={`multiselect${id}`} ref={selectRef}>
      <Select
        isMulti
        closeMenuOnSelect={false}
        options={column.filterOptions}
        value={normalizedValue}
        onChange={onChange}
        isDisabled={column.isDisabled}
        placeholder=""
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        isClearable={false}
        tabSelectsValue={false}
        menuPosition="fixed"
        openMenuOnFocus={false}
        menuIsOpen={open}
        onMenuOpen={() => setOpen(true)}
        onMenuClose={() => setOpen(false)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        components={{
          DropdownIndicator: () => null, // Removes the dropdown arrow
          IndicatorSeparator: () => null // Optionally removes the vertical line separator
        }}
        styles={{
          ...customMultiSelectStyles,

        }}
      />
    </div>
  );
};

export default MultiSelectFilter;
